module.exports = __webpack_public_path__ + "static/media/icon-trash-white.8b18c71c.svg";